import { IFetchResponse } from 'interface/http';
import { useEffect, useMemo, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { BLOG_API_BASE_URL } from '../../../constants';
import axios from 'axios';
import { EArticleCategory } from './Definitions/Article.d';

type TResponse = IFetchResponse<ArticleCategory.Data[]>;

interface IUseFetchArticleCategoriesProps {
  slug?: string | string[];
  stopFetch?: boolean;
}

export const useFetchArticleCategories = (
  props: IUseFetchArticleCategoriesProps,
) => {
  const { slug, stopFetch } = props;

  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [data, setData] = useState<ArticleCategory.Data[]>([]);
  const [response, setResponse] = useState<TResponse>();

  const description = useMemo(() => {
    if(isFetching){
      return '';
    }

    if(slug === 'latest'){
      return '';
    }

    if (!data.length) {
      return '';
    }
    
    return data[0].description;
  }, [slug, isFetching, data]);

  const getDescription = () => {
    if(slug === 'latest'){
      return '';
    }

    if (!data.length) {
      return '';
    }

    return data[0].description;
  };

  const getDescriptionBySlug = (paramSlug: string) => {
    if(paramSlug === 'latest'){
      return '';
    }
    
    if (!data.length) {
      return '';
    }

    const found = data.find((el) => el.slug === paramSlug);

    if (found) {
      return found.description;
    }

    return '';
  };

  useEffect(() => {
    if (stopFetch) {
      return;
    }

    let fetchUrl = `${BLOG_API_BASE_URL}/article-categories?no_limit=true`;
    const slugException = [EArticleCategory.Latest] as string[];

    if (slug) {
      if (Array.isArray(slug) && slug.length > 0) {
        const strSlug = slug
          .filter((el) => !slugException.includes(el))
          .join(',');
        fetchUrl += `&slug=${strSlug}`;
      }

      if (typeof slug === 'string' && slug.length > 0) {
        if (slugException.includes(slug)) {
          return;
        }
        fetchUrl += `&slug=${slug}`;
      }
    }

    setIsFetching(true);
    axios
      .get<TResponse>(fetchUrl)
      .then((res) => {
        const responseData = res.data.data;
        setTimeout(() => {
          setIsFetching(false);
        }, 1000);
        setIsError(false);
        setResponse(res.data);
        setData(responseData);
      })
      .catch((err) => {
        console.log('failed to fetch article categories', err);
        setIsFetching(false);
        setIsError(true);
      });

    return () => {
      setIsError(false);
      setIsFetching(false);
      setData([]);
      setResponse(undefined);
    };
  }, [slug, stopFetch]);

  return {
    isFetching,
    isError,
    data,
    response,
    description,
    getDescription,
    getDescriptionBySlug,
  };
};
